import Axios from 'axios'
import EndpointFactory from 'axios-endpoints'

const CONFIG = {
  baseURL: process.env.APP_ERP,
  headers: {
    'Content-Type': 'application/json',
    'bu': 'empiricus',
    'channel': 'services',
  },
}

const CONFIG_TOKEN = {
  baseURL: process.env.APP_ERP,
  headers: {
    'Content-Type': 'application/json',
    'channel': 'services',
    'bu': 'empiricus',
  },
}

const CONFIG_ACCESS = {
  baseURL: process.env.ROOT_API_CONTENT_IA,
  headers: {
    'Content-Type': 'application/json',
    'channel': 'services',
    'bu': 'empiricus',
  }
}

const CONFIG_LOGS = {
  baseURL: process.env.ROOT_API_SMSPUSH,
  headers: {
    'Content-Type': 'application/json',
    'channel': 'services',
    'bu': 'empiricus',
  }
}
//config

const CONFIG_SERVICE = {
  baseURL: process.env.ROOT_API_LOGS,
  headers: {
    'Content-Type': 'application/json',
    'channel': 'services',
    'bu': 'empiricus',
  }
}

const CONFIG_SHORTNER = {
  baseURL: process.env.ROOT_API_SHORTNER,
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
    'channel': 'services',
    'bu': 'empiricus',
  }
}

const CONFIG_PUSH_WEB_SCHEDULES = {
  baseURL: process.env.ROOT_API_PUSHWEB,
  headers: {
    'Content-Type': 'application/json;',
    'channel': 'services',
    'bu': 'empiricus',
  }
}

const CONFIG_PUSH_WEB = {
  baseURL: process.env.ROOT_API_PUSHWEB,
  headers: {
    "Content-Type": "multipart/form-data",
    'channel': 'services',
    'bu': 'empiricus',
  }
}

const CONFIG_SPLIT_AB = {
  baseURL: process.env.ROOT_TESTAB,
  headers: {
    'Content-Type': 'application/json;',
    'channel': 'services',
    'bu': 'empiricus',
  }
}

const CONFIG_LOG_PUSH = {
  baseURL: process.env.ROOT_API_LOG_PUSH,
  headers: {
    'Content-Type': 'application/json;',
    'channel': 'services',
    'bu': 'empiricus',
  }
}

const CONFIG_FACEBOOK = {
  baseURL: process.env.ROOT_API_FACEBOOK,
  headers: {
    'Content-Type': 'application/json',
    "Access-Control-Allow-Origin": "*",
    'channel': 'services',
    'bu': 'empiricus',
  }
}

const CONFIG_PUSH_WEB_CANCEL = {
  baseURL: process.env.ROOT_API_PUSHWEB_CANCEL,
  headers: {
    'Content-Type': 'application/json;',
    'channel': 'services',
    'bu': 'empiricus',
  }
}

const CONFIG_SMS_USERS = {
  baseURL: process.env.ROOT_API_USERS,
  headers: {
    'Content-Type': 'application/json;',
    'channel': 'services',
    'bu': 'empiricus',
  }
}

const apiAcc = Axios.create(CONFIG_ACCESS)
const apiAuth = Axios.create(CONFIG)
const apiAuthenticated = Axios.create(CONFIG_TOKEN)
const apiLogs = Axios.create(CONFIG_LOGS)
//const config dos logs
const apiServ = Axios.create(CONFIG_SERVICE)
const apiShortner = Axios.create(CONFIG_SHORTNER)
const pushWebSchedule = Axios.create(CONFIG_PUSH_WEB_SCHEDULES)
const pushWeb = Axios.create(CONFIG_PUSH_WEB)
const splitAb = Axios.create(CONFIG_SPLIT_AB)
const logsPush = Axios.create(CONFIG_LOG_PUSH)
const apiFacebook = Axios.create(CONFIG_FACEBOOK)
const pushWebCancel = Axios.create(CONFIG_PUSH_WEB_CANCEL)
const smsUsers = Axios.create(CONFIG_SMS_USERS)


const EndpointAuth = EndpointFactory(apiAcc)
const Endpoint = EndpointFactory(apiAuth)
const EndpointAutheticated = EndpointFactory(apiAuthenticated)
const EndpointLogs = EndpointFactory(apiLogs)
const EndpointServ = EndpointFactory(apiServ)
const EndpointShort = EndpointFactory(apiShortner)
const EndpointPushWebSchedule = EndpointFactory(pushWebSchedule)
const EndpointPushWeb = EndpointFactory(pushWeb)
const EndpointSplit = EndpointFactory(splitAb)
const EndpointPush = EndpointFactory(logsPush)
const EndpointFacebook = EndpointFactory(apiFacebook)
const EndpointPushWebCancel = EndpointFactory(pushWebCancel)
const EndpointSmsList = EndpointFactory(apiLogs)
const EndpointSmsUsers = EndpointFactory(smsUsers)
//apontando config no endpoint

// Login
export const getUserDetails = new EndpointAutheticated('/v1/accounts/users/me')
export const postUserLogin = new Endpoint('/v1/accounts/auth/login')
export const postUserLogout = new EndpointAutheticated('/v1/accounts/users/me/logout')

// Roles Usuário
export const rolesUser = new EndpointLogs('/users/roles')

// Products
export const getAllProducts = new EndpointAuth(({page, size}) => `/products?page=${page}&size=${size}`)
export const getFilteredProducts = new EndpointAuth(({is_active, page, size}) => `/products?is_active=${is_active}&page=${page}&size=${size}`)
export const postProduct = new EndpointAuth('/products')
export const updateProduct = new EndpointAuth(({id}) => `/products/${id}`)
export const disableProduct = new EndpointAuth(({id}) => `/products/${id}`)

// Copy
export const getAllCopies = new EndpointAuth(({page, size, product_id}) => `/copies?page=${page}&size=${size}&product_id=${product_id}`)
export const getFilteredCopies = new EndpointAuth(({is_active, page, size, product_id}) => `/copies?is_active=${is_active}&page=${page}&size=${size}&product_id=${product_id}`)
export const postCopy = new EndpointAuth('/copies')
export const updateCopy = new EndpointAuth(({id}) => `/copies/${id}`)
export const disableCopy = new EndpointAuth(({id}) => `/copies/${id}`)

// Communication
export const getAllCommunications = new EndpointAuth(({page, size, product_id, search_text}) => `/communications?page=${page}&size=${size}&product_id=${product_id}&search_text=${search_text}`)
export const getFilteredCommunications = new EndpointAuth(({is_active, page, size, product_id, search_text}) => `/communications?is_active=${is_active}&page=${page}&size=${size}&product_id=${product_id}&search_text=${search_text}`)
export const postCommunication = new EndpointAuth('/communications')
export const updateCommunication = new EndpointAuth(({id}) => `/communications/${id}`)
export const disableCommunication = new EndpointAuth(({id}) => `/communications/${id}`)

// Logs
export const getAllLogs = new EndpointLogs(({current_page, page_size}) => `/api/getMessages?page=${current_page}&size=${page_size}`)
export const postLogs = new EndpointLogs(`/api/sendMessage`)
export const getServices = new EndpointServ(`/api/getServices`)
export const updateMessages = new EndpointAuth(({id}) => `/api/getMessages/${id}`)
export const groups = new EndpointLogs(`/users/groups`)

export const logsPushApp = new EndpointPush(({current_page, page_size}) => `/api/sentRequisitionsByUserFiltered?serviceFilter=SMSPUSHAPP&page=${current_page}&size=${page_size}`)
export const logsFilterPushApp = new EndpointPush(({current_page, page_size, filter}) => `/api/sentRequisitionsByUserFiltered?serviceFilter=SMSPUSHAPP&page=${current_page}&size=${page_size}${filter}`)
export const getLogsPushAppDetails = new EndpointPush(({idUser}) => `/api/messageSentByUser?idUser=${idUser}&typeMessage=SMSPUSHAPP`)

// Push Web
export const getAllPushWebSchedules = new EndpointPushWebSchedule(({current_page, page_size, search}) => `/api/getAllPushNotifications?page=${current_page}&size=${page_size}${search}`)
export const filterPushLogs = new EndpointLogs(({page_size, current_page, title, to, from, channelType, message}) => `/api/getMessages?&page=${current_page}&size=${page_size}&title=${title}&channelType=${channelType}&to=${to}&from=${from}&message=${message}`)
export const getAllPushLogs = new EndpointPush(({current_page, page_size, search}) => `/api/sentRequisitionsByUserFiltered?serviceFilter=PUSHWEB&page=${current_page ? current_page : 0}&size=${page_size}${search}`)
export const getAllowedsToCancel = new EndpointPushWebCancel(() => `/pushweb/findNotificationsToCancel/findById?id=`)
export const cancelScheddule = new EndpointPushWebCancel(() => `/cancelWebNotifications`)
export const getFilterLogsPush = new EndpointLogs(({current_page, page_size, filter}) => `/api/getMessages?&page=${current_page}&size=${page_size}${filter}`)
export const getLogsPushWebDetails = new EndpointServ(({idUser}) => `/api/messageSentByUser?idUser=${idUser}&typeMessage=PUSHWEB`)
export const getFilterLogs = new EndpointLogs(({page_size, current_page, title, to, from, channelType, smsContent, message}) => `/api/getMessages?&page=${current_page}&size=${page_size}&title=${title}&channelType=${channelType}&to=${to}&from=${from}&message=${message}&smsContent=${smsContent}`)
export const postPushWeb = new EndpointPushWeb(`/api/createWebNotification`)

// Shortner EndpointShort
export const shortUrl = new EndpointShort(`/api/create`)
export const getShortUrl = new EndpointShort(({url}) => `/api/getShortUrl?shortUrl=${url}`)
export const getHistoryUrl = new EndpointShort(({url}) => `/api/getHistoryUrl?shortUrl=${url}`)
export const getUrlLong = new EndpointShort(({url}) => `/api/getLongUrl?longUrl=${url}`)
export const updateLongUrl = new EndpointShort(`/api/updateLongUrl`)
export const customUrl = new EndpointShort(`/api/createCustom`)

// Teste AB
export const createABUrl = new EndpointShort(`/api/createABUrl`)
export const splitABUrl = new EndpointSplit(({page, size}) => `/api/testAbLogs?page=${page}&size=${size}`)
export const oldLogsSplitABUrl = new EndpointSplit(({page, size}) => `/logs/testAbUpdateLogs?page=${page}&size=${size}`)
export const splitABUrlFilter = new EndpointSplit(({page, size, filter}) => `/api/testAbLogs?page=${page}&size=${size}${filter}`)
export const oldLogsSplitABUrlFilter = new EndpointSplit(({page, size, filter}) => `/logs/testAbUpdateLogs?page=${page}&size=${size}${filter}`)
export const splitABUrlEdit = new EndpointSplit(({test_name}) => `/api/${test_name}`)

// Facebook
export const getAllForms = new EndpointFacebook(({page, size, product_id, search_text}) => `/forms?page=${page}&size=${size+1}${search_text ? search_text : ''}`)
export const updateFacebook = new EndpointFacebook(({id}) => `/forms/${id}`)
export const postFacebookErp = new EndpointFacebook('/forms')
export const deleteFacebookForm = new EndpointFacebook(({id}) => `/forms/${id}`)

// SMS Lists
export const getSmsLists = new EndpointSmsList(({page, size}) => `/groups?page=${page}&size=${size}`)
export const postSmsList = new EndpointSmsList('/groups')
export const updateSmsList = new EndpointSmsList(({id}) => `/groups/${id}`)
export const disableSmsList = new EndpointSmsList(({id}) => `/groups/${id}`)
export const getFilteredSmsList = new EndpointSmsList(({page, size, listName}) => `/groups?page=${page}&size=${size}&listName=${listName}`)

//SMS Users List
export const getUsersList = new EndpointSmsUsers(({ page, size }) => `/users?page=${page}&size=${size}`)
export const getByUsersEmail = new EndpointSmsUsers(({ page, size, search }) => `/users?page=${page}&email=${search}&size=${size}`)
export const getByUsersName = new EndpointSmsUsers(({ page, size, search }) => `/users?page=${page}&name=${search}&size=${size}`)
export const getByUsersActaId = new EndpointSmsUsers(({ search }) => `/users/${search}`);


export const getListFromUser = new EndpointLogs(({acta_user_id}) => `users/groups/${acta_user_id}`)
export const postListFromUser = new EndpointLogs(({id_group, acta_user_id}) => `users/groups/${id_group}/${acta_user_id}`)
export const deleteListFromUser = new EndpointLogs(({id_group, acta_user_id}) => `users/groups/${id_group}/${acta_user_id}`)



// export const postListFromUser = new EndpointSmsUsers( `users/groups/89/6047853`)


// WEBPACK FOOTER //
// ./src/api/Erp.js